import cloneDeep from 'lodash/cloneDeep';
export var adyenConfig;
export var adyenPaymentMethodConfig;
export var updateConfigs = function () {
    adyenConfig = cloneDeep(Object.assign({}, window.AdyenConfiguration));
    adyenPaymentMethodConfig = cloneDeep(Object.assign({}, window.PaymentMethodConfiguration));
};
